import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#f50057' },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      ml: 1080,
      lg: 1200,
      xl: 1536,
    },
  },
});



export default theme;
